export const infoTooltipText =
  'The Credit Quality Score (CQS) can be used to identify companies with upgrade or downgrade potential. The higher the CQS, the higher the medium-term credit quality of the company (ACR is the agency composite rating).';
